import { action } from '@storybook/addon-actions';

import { createUID } from '@pega/cosmos-react-core';
import type { FieldValueListProps, MenuProps } from '@pega/cosmos-react-core';
import type {
  ChatBodyListItemProps,
  ChatBodyProps,
  SuggestedReply
} from '@pega/cosmos-react-social';

export const BotConversation: ChatBodyProps['liveChat'] = [
  {
    id: createUID(),
    type: 'message',
    senderType: 'bot',
    direction: 'in',
    senderId: 'bot1',
    message: 'Hi, Welcome to u-plus. How can I help you ?',
    timestamp: '1:44 PM'
  },
  {
    id: createUID(),
    type: 'message',
    senderType: 'customer',
    direction: 'in',
    avatarInfo: {
      name: 'Ginger Ventura'
    },
    timestamp: '1:45 PM',
    senderId: 'gingerVentura',
    message: 'Hi, I would like to know the validity of my policy.'
  },
  {
    id: createUID(),
    type: 'message',
    senderType: 'bot',
    direction: 'in',
    senderId: 'bot1',
    message: 'You have two policies.'
  },
  {
    id: createUID(),
    type: 'message',
    senderType: 'bot',
    direction: 'in',
    senderId: 'bot1',
    message: '1457589, 1473284.'
  },
  {
    id: createUID(),
    type: 'message',
    senderType: 'bot',
    direction: 'in',
    senderId: 'bot1',
    message: 'Which among these policies do you want to know the validity of?',
    timestamp: '1:45 PM'
  },
  {
    id: createUID(),
    type: 'message',
    senderType: 'customer',
    direction: 'in',
    avatarInfo: {
      name: 'Ginger Ventura'
    },
    timestamp: '1:47 PM',
    senderId: 'gingerVentura',
    message: 'Please give me validity of policy with number 1457589.'
  },
  {
    id: createUID(),
    type: 'message',
    senderType: 'bot',
    direction: 'in',
    senderId: 'bot1',
    timestamp: '1:48 PM',
    message: 'Policy with number 1457589 is expiring on 12th December, 2023.'
  },
  {
    id: createUID(),
    type: 'message',
    senderType: 'bot',
    direction: 'in',
    senderId: 'bot1',
    timestamp: '1:49 PM',
    message: 'Is there anything else that you need help with?'
  },
  {
    id: createUID(),
    type: 'message',
    senderType: 'customer',
    direction: 'in',
    avatarInfo: {
      name: 'Ginger Ventura'
    },
    timestamp: '1:51 PM',
    senderId: 'gingerVentura',
    message: 'Yes, I would like to know about the claims process.'
  },
  {
    id: createUID(),
    type: 'message',
    senderType: 'bot',
    direction: 'in',
    senderId: 'bot1',
    timestamp: '1:52 PM',
    message: 'Sure, I am transferring this chat to the concerned department.'
  },
  {
    id: createUID(),
    type: 'system',
    timestamp: '1:52 PM',
    message: 'Chat routed to a live agent.'
  }
];

export const ClaimsAgentConversation: ChatBodyProps['liveChat'] = [
  {
    id: createUID(),
    type: 'system',
    timestamp: '1:54 PM',
    message: 'John Brown joined this conversation'
  },
  {
    id: createUID(),
    type: 'message',
    senderType: 'agent',
    direction: 'in',
    avatarInfo: {
      name: 'John Brown'
    },
    senderId: 'agent1',
    message: 'Hi Ginger Ventura, I see that you want to know about the claims process.'
  },
  {
    id: createUID(),
    type: 'message',
    senderType: 'agent',
    direction: 'in',
    avatarInfo: {
      name: 'John Brown'
    },
    senderId: 'agent1',
    message: 'Please go to link to get detailed information about claims process.',
    timestamp: '1:55 PM',
    mediaPageLinks: [
      {
        id: createUID(),
        href: 'https://collaborate.pega.com/',
        thumbnail:
          'https://community.pega.com/sites/default/files/styles/480/public/media/images/2020-02/AskExpert.png?itok=ef2MVbOV',
        title: 'UPlus - Claims process'
      }
    ]
  },
  {
    id: createUID(),
    type: 'system',
    timestamp: '1:56 PM',
    message: 'Vernon Lee joined this conversation'
  },
  {
    id: createUID(),
    type: 'message',
    senderType: 'agent',
    direction: 'in',
    avatarInfo: {
      name: 'Vernon Lee'
    },
    senderId: 'agent2',
    message:
      'Hi Ginger Ventura, I am the supervisor. You may also contact the nearest branch for a physical copy of the claims process.',
    timestamp: '1:57 PM'
  },
  {
    id: createUID(),
    type: 'message',
    senderType: 'customer',
    direction: 'in',
    avatarInfo: {
      name: 'Ginger Ventura'
    },
    timestamp: '1:57 PM',
    senderId: 'gingerVentura',
    message:
      'Thanks for the information. I would also like to update the mobile number of my policy.'
  },
  {
    id: createUID(),
    type: 'message',
    senderType: 'agent',
    direction: 'in',
    avatarInfo: {
      name: 'John Brown'
    },
    senderId: 'agent1',
    message: 'Sure, I need to transfer you to a specialist to get you the needed help.',
    timestamp: '1:58 PM'
  },
  {
    id: createUID(),
    type: 'message',
    senderType: 'customer',
    direction: 'in',
    avatarInfo: {
      name: 'Ginger Ventura'
    },
    timestamp: '1:58 PM',
    senderId: 'gingerVentura',
    message: 'Okay.'
  },
  {
    id: createUID(),
    type: 'system',
    timestamp: '1:59 PM',
    message: 'Transfer request initiated'
  }
];
export const LiveChatConversation: ChatBodyProps['liveChat'] = [
  {
    id: createUID(),
    type: 'system',
    timestamp: '2:01 PM',
    message: 'Edward Green joined the conversation'
  },
  {
    id: createUID(),
    type: 'message',
    senderType: 'agent',
    direction: 'out',
    avatarInfo: {
      name: 'Edward green'
    },
    senderId: 'agent3',
    message: 'Hi Ginger Ventura, Please provide your phone number that needs to be updated.',
    timestamp: '2:02PM'
  },
  {
    id: createUID(),
    type: 'message',
    senderType: 'customer',
    direction: 'in',
    avatarInfo: {
      name: 'Ginger Ventura'
    },
    timestamp: '2:03 PM',
    senderId: 'gingerVentura',
    message: 'Please update the policy with 9812764132.'
  },
  {
    id: createUID(),
    type: 'message',
    senderType: 'agent',
    direction: 'out',
    avatarInfo: {
      name: 'Edward green'
    },
    senderId: 'agent3',
    message: 'Your mobile number is updated successfully.'
  },
  {
    id: createUID(),
    type: 'message',
    senderType: 'agent',
    direction: 'out',
    avatarInfo: {
      name: 'Edward green'
    },
    senderId: 'agent3',
    message: 'This number will be used for all communcation regarding your policy',
    timestamp: '2:05 PM',
    status: 'delivered'
  },
  {
    id: createUID(),
    type: 'system',
    timestamp: '2:04 PM',
    message: 'Vernon Lee joined this conversation'
  },
  {
    id: createUID(),
    type: 'message',
    senderType: 'agent',
    direction: 'in',
    avatarInfo: {
      name: 'Vernon Lee'
    },
    senderId: 'agent2',
    message: 'Please download the updated policy',
    attachments: [
      {
        id: createUID(),
        name: 'Policy',
        icon: 'document-pdf',
        meta: 'PDF 1.2 MB',
        thumbnail:
          'https://pegasystems.github.io/uplus-wss/health_provider/img/secondary-options.jpg'
      },
      {
        id: createUID(),
        name: 'FAQ with detailed terms and conditions of the policy',
        icon: 'document-pdf',
        meta: 'PDF 0.7 MB'
      }
    ],
    timestamp: '2:05 PM'
  },

  {
    id: createUID(),
    type: 'message',
    senderType: 'agent',
    direction: 'out',
    avatarInfo: {
      name: 'Edward green'
    },
    senderId: 'agent3',
    message: 'Here is an article you may find valuable',
    timestamp: '2:05 PM',
    status: 'delivered',
    mediaPageLinks: [
      {
        id: '2499167349',
        href: 'https://collaborate.pega.com/',
        title: 'Ask the expert'
      }
    ]
  },
  {
    id: createUID(),
    type: 'message',
    senderType: 'agent',
    direction: 'out',
    avatarInfo: {
      name: 'Edward green'
    },
    senderId: 'agent3',
    message: 'Here is an article you may find valuable',
    timestamp: '2:05 PM',
    status: 'delivered',
    mediaPageLinks: [
      {
        id: '2499167349',
        title: 'Ask the expert now',
        onTitleClick: () => {
          action('open KM article');
        }
      }
    ]
  },
  {
    id: createUID(),
    type: 'message',
    senderType: 'customer',
    direction: 'in',
    avatarInfo: {
      name: 'Ginger Ventura'
    },
    timestamp: '2:06 PM',
    senderId: 'gingerVentura',
    message: 'Thank you'
  }
];

export const SimulatedConversation: ChatBodyProps['liveChat'] = [
  {
    id: createUID(),
    type: 'message',
    senderType: 'agent',
    direction: 'out',
    avatarInfo: {
      name: 'Edward green'
    },
    senderId: 'agent3',
    message: 'You are welcome, Is there anything else you need help with?',
    timestamp: '2:07 PM'
  },
  {
    id: createUID(),
    type: 'message',
    senderType: 'customer',
    direction: 'in',
    avatarInfo: {
      name: 'Ginger Ventura'
    },
    timestamp: '2:09 PM',
    senderId: 'gingerVentura',
    message: 'Can you please let me know the information about the newly launched policies?'
  },
  {
    id: createUID(),
    type: 'message',
    senderType: 'agent',
    direction: 'out',
    avatarInfo: {
      name: 'Edward green'
    },
    senderId: 'agent3',
    message: 'We have new plans in term insurance and health insurance.'
  },
  {
    id: createUID(),
    type: 'message',
    senderType: 'agent',
    direction: 'out',
    avatarInfo: {
      name: 'Edward green'
    },
    senderId: 'agent3',
    message: 'Do you want me to share the information on both?',
    timestamp: '2:10 PM'
  },
  {
    id: createUID(),
    type: 'message',
    senderType: 'customer',
    direction: 'in',
    avatarInfo: {
      name: 'Ginger Ventura'
    },
    senderId: 'gingerVentura',
    message: 'Yes, please.'
  },
  {
    id: createUID(),
    type: 'message',
    senderType: 'customer',
    direction: 'in',
    avatarInfo: {
      name: 'Ginger Ventura'
    },
    senderId: 'gingerVentura',
    message: 'I am also interested in knowing endowment plans as well.',
    timestamp: '2:11 PM'
  },
  {
    id: createUID(),
    type: 'message',
    senderType: 'agent',
    direction: 'out',
    avatarInfo: {
      name: 'Edward green'
    },
    senderId: 'agent3',
    message: 'Okay, Let me find the relevant information for you.',
    timestamp: '2:12 PM'
  },
  {
    id: createUID(),
    type: 'message',
    senderType: 'agent',
    direction: 'in',
    avatarInfo: {
      name: 'Vernon Lee'
    },
    senderId: 'agent2',
    message: 'We have a newly launched pension plan as well. Would you be interested in it?',
    timestamp: '2:12 PM'
  },
  {
    id: createUID(),
    type: 'message',
    senderType: 'customer',
    direction: 'in',
    avatarInfo: {
      name: 'Ginger Ventura'
    },
    senderId: 'gingerVentura',
    message:
      'I am not looking for a pension plan at the moment. However, share the details of this plan also.',
    timestamp: '2:13 PM'
  },
  {
    id: createUID(),
    type: 'message',
    senderType: 'agent',
    direction: 'in',
    avatarInfo: {
      name: 'Vernon Lee'
    },
    senderId: 'agent2',
    message: 'Sure, I share the details in a moment.',
    timestamp: '2:14 PM'
  },
  {
    id: createUID(),
    type: 'message',
    senderType: 'agent',
    direction: 'out',
    avatarInfo: {
      name: 'Edward green'
    },
    senderId: 'agent3',
    message: 'You can find details of the term insurance in this link',
    mediaPageLinks: [
      {
        id: createUID(),
        href: 'https://pegasystems.github.io/uplus-wss/insurance/index.html',
        thumbnail: 'https://pegasystems.github.io/uplus-wss/insurance/img/offer-promo-1.jpg',
        title: 'Ask the expert'
      }
    ]
  },
  {
    id: createUID(),
    type: 'message',
    senderType: 'agent',
    direction: 'out',
    avatarInfo: {
      name: 'Edward green'
    },
    senderId: 'agent3',
    message: 'Health insurance details can be found here',
    mediaPageLinks: [
      {
        id: createUID(),
        href: 'https://pegasystems.github.io/uplus-wss/insurance/offer.html',
        thumbnail: 'https://pegasystems.github.io/uplus-wss/insurance/img/offer-main.jpg',
        title: 'Ask the expert'
      }
    ],
    timestamp: '2:15 PM'
  },
  {
    id: createUID(),
    type: 'message',
    senderType: 'agent',
    direction: 'in',
    avatarInfo: {
      name: 'Vernon Lee'
    },
    senderId: 'agent2',
    message: 'Visit this link for details on pension plan',
    mediaPageLinks: [
      {
        id: createUID(),
        href: 'https://pegasystems.github.io/uplus-wss/retail_bank/index.html',
        thumbnail: 'https://pegasystems.github.io/uplus-wss/retail_bank/img/offer-main.jpg',
        title: 'Ask the expert'
      }
    ],
    timestamp: '2:15 PM'
  },
  {
    id: createUID(),
    type: 'message',
    senderType: 'agent',
    direction: 'out',
    avatarInfo: {
      name: 'Edward green'
    },
    senderId: 'agent3',
    message: 'Here are the details of endowment plans',
    attachments: [
      {
        id: createUID(),
        name: 'Policy',
        icon: 'document-pdf',
        meta: 'PDF 1.2 MB',
        thumbnail:
          'https://pegasystems.github.io/uplus-wss/health_provider/img/secondary-options.jpg'
      }
    ],
    timestamp: '2:16 PM'
  },
  {
    id: createUID(),
    type: 'message',
    senderType: 'customer',
    direction: 'in',
    avatarInfo: {
      name: 'Ginger Ventura'
    },
    senderId: 'gingerVentura',
    message: 'Great, Thank you',
    timestamp: '2:17 PM'
  },
  {
    id: createUID(),
    type: 'system',
    message: 'Customer left this conversation',
    timestamp: '2:19 PM'
  }
];

export const ChatMockData: {
  chatMessages: ChatBodyListItemProps[];
  suggestedReplies: SuggestedReply[];
} = {
  chatMessages: SimulatedConversation,
  suggestedReplies: [
    {
      id: 'suggested_reply_1',
      message: 'Thanks for contacting our support team.',
      type: 'dialog'
    },
    {
      id: 'suggested_reply_2',
      message:
        'You can certainly avoid sign up fees when opening future accounts, check out the **following articles**: \n \n - [Avoid sign up fees](https://www.pega.com) \n - [This is an example of a very long hyperlink label that might wrap to the next line](https://www.pega.com)',
      type: 'genAIReply'
    },
    {
      id: 'suggested_reply_3',
      message:
        'You can certainly avoid sign up fees when opening future accounts, check out the **following articles**: \n \n [Avoid sign up fees](https://www.pega.com) \n [This is an example of a very long hyperlink label that might wrap to the next line](https://www.pega.com)',
      type: 'genAIReply'
    }
  ]
};

export const phrasesDisplayNames: MenuProps['items'] = [
  {
    id: '1',
    primary: 'Account',
    items: [
      {
        id: '1-1',
        primary: 'Account balance'
      }
    ]
  },
  {
    id: '2',
    primary: 'Agreement',
    items: [
      {
        id: '2-1',
        primary: 'End of a case/interaction'
      },
      {
        id: '2-2',
        primary: 'Mid interaction'
      }
    ]
  },
  {
    id: '3',
    primary: 'Apologize',
    items: [
      {
        id: '3-1',
        primary: 'Apologize - ask customer to'
      },
      {
        id: '3-2',
        primary: 'Thanks for patience'
      }
    ]
  },
  {
    id: '4',
    primary: 'Ask for transfer',
    items: [
      {
        id: '4-1',
        primary: 'Agent not available'
      },
      {
        id: '4-2',
        primary: 'Agent not available - call back'
      },
      {
        id: '4-3',
        primary: 'Agent not available - stall'
      }
    ]
  }
];

export const phrasesMessages = [
  {
    id: '1-1',
    message: 'Ms. Ginger ventura your account balance is $5226.32'
  },
  {
    id: '2-1',
    message: 'My pleasure! Is there anything else I can do for you today?'
  },
  {
    id: '2-2',
    message: 'You are welcome!'
  },
  {
    id: '3-1',
    message:
      "Ms.Ventura. We do not respond to that kind of language. I'm doing my best to help you. Please be civil."
  },
  {
    id: '3-2',
    message: 'Thanks for your patience. I am working on your request. I will be with you shortly.'
  },
  {
    id: '4-1',
    message:
      'It looks like the agent we were looking to transfer you to will not be available. One moment please while I see whether someone else can assist.'
  },
  {
    id: '4-2',
    message:
      "The agent I was looking to transfer you to isn't available. Would it be possible for us to call you when a specialist is available?"
  },
  {
    id: '4-3',
    message:
      'It looks like the agent we were looking to transfer you to will not be available. One moment please while I see whether someone else can assist.'
  }
];

export const pagePushList = [
  {
    id: createUID(),
    type: 'message',
    senderType: 'agent',
    senderId: 'agent3',
    direction: 'out',
    avatarInfo: {
      name: 'Edward green'
    },
    message: 'You may also reach us via',
    timestamp: '1:45 PM',
    mediaPageLinks: [
      {
        id: createUID(),
        href: 'https://collaborate.pega.com/',
        thumbnail:
          'https://community.pega.com/sites/default/files/styles/480/public/media/images/2020-02/AskExpert.png?itok=ef2MVbOV',
        title: 'Ask the expert'
      }
    ]
  },
  {
    id: createUID(),
    type: 'message',
    senderType: 'agent',
    senderId: 'agent3',
    direction: 'out',
    avatarInfo: {
      name: 'Edward green'
    },
    message: 'Online Portal',
    timestamp: '1:45 PM',
    mediaPageLinks: [
      {
        id: createUID(),
        href: 'https://collaborate.pega.com/',
        title: 'Ask the expert'
      }
    ]
  },
  {
    id: createUID(),
    type: 'message',
    senderType: 'agent',
    senderId: 'agent3',
    direction: 'out',
    avatarInfo: {
      name: 'Edward green'
    },
    message: 'Contact center',
    timestamp: '1:45 PM',
    mediaPageLinks: [
      {
        id: createUID(),
        href: 'https://collaborate.pega.com/',
        title: 'Ask the expert'
      }
    ]
  }
];

export const contextItems: FieldValueListProps['fields'] = [
  {
    id: 'Location',
    name: 'Location',
    value: 'New York, NY',
    variant: 'inline'
  },
  {
    id: 'Initiated from',
    name: 'Initiated from',
    value: 'Uplus.com/Products',
    variant: 'inline'
  },
  {
    id: 'Shopping cart',
    name: 'Shopping cart',
    value: '$155.25',
    variant: 'inline'
  },
  {
    id: 'Items in shopping cart',
    name: 'Items in shopping cart',
    value: 'Product name 01, Product name 02',
    variant: 'inline'
  }
];
